import lodash from 'lodash';
import { IAllocationSalesHelper, IAllocationSalesHelperStock, Maybe, ProductClass } from '../graphql/schema/p4types';

export function autoDeallocate(allocationSalesHelpers: Array<IAllocationSalesHelper>) {
  const newAllocationSalesHelperContainer: Array<IAllocationSalesHelper> = [];
  for (const allocationSalesHelper of allocationSalesHelpers) {
    const newAllocationSalesHelper: IAllocationSalesHelper = lodash.cloneDeep(allocationSalesHelper);

    const previousAllocation = newAllocationSalesHelper.allocated;
    const previousProduction = newAllocationSalesHelper.inProduction;

    if (allocationSalesHelper.product?.leveled) {
      newAllocationSalesHelper.makeable += previousProduction;
      newAllocationSalesHelper.freeStock += previousAllocation;
    }

    const required = Math.max(0, newAllocationSalesHelper.quantity - newAllocationSalesHelper.dispatched);

    newAllocationSalesHelper.required = required;
    if (allocationSalesHelper.product?.productClass === ProductClass.Kit) {
      newAllocationSalesHelper.productionRequired = required;
    } else {
      newAllocationSalesHelper.productionRequired = 0;
    }

    newAllocationSalesHelper.allocated = 0;
    newAllocationSalesHelper.inProduction = 0;

    newAllocationSalesHelper.allocationSalesHelperStock
      ?.filter((ashs) => !!ashs)
      .forEach((allocationSalesHelperStock) => {
        allocationSalesHelperStock!.allocation = 0;
      });

    newAllocationSalesHelper.unReserveAll = false;
    newAllocationSalesHelper.deallocateAll = true;
    newAllocationSalesHelperContainer.push(newAllocationSalesHelper);
  }

  return newAllocationSalesHelperContainer;
}

export function autoUnreserve(allocationSalesHelpers: Array<IAllocationSalesHelper>) {
  const newAllocationSalesHelperContainer: Array<IAllocationSalesHelper> = [];
  for (const allocationSalesHelper of allocationSalesHelpers) {
    const newAllocationSalesHelper: IAllocationSalesHelper = lodash.cloneDeep(allocationSalesHelper);

    if (
      allocationSalesHelper.product?.productClass === ProductClass.Kit &&
      newAllocationSalesHelper.allocationSalesHelperStock
    ) {
      for (const allocationSalesHelperStock of newAllocationSalesHelper.allocationSalesHelperStock) {
        if (!allocationSalesHelperStock) continue;
        if (allocationSalesHelperStock.reserved > 0) {
          allocationSalesHelperStock.reservation = -allocationSalesHelperStock.reserved;
        } else {
          allocationSalesHelperStock.reservation = 0;
        }
      }
    }

    if (
      allocationSalesHelper.product?.productClass === ProductClass.Kit ||
      allocationSalesHelper.product?.productClass === ProductClass.Assembly
    ) {
      newAllocationSalesHelper.unReserveAll = true;
    }

    newAllocationSalesHelperContainer.push(newAllocationSalesHelper);
  }

  return newAllocationSalesHelperContainer;
}
